import React from 'react';
import { compose } from 'recompose';
import { withTheme } from 'styled-components';

import { IThemeObject } from 'pods/theme';
import ExperienceEditorContent from 'core/sitecore/experience-editor/ExperienceEditorContent';
import { withExperienceEditorContext } from 'core/sitecore/ExperienceEditorContext';
import {
	withMemberContext,
	isAuthenticated,
	isMultipleAccounts,
} from 'core/sitecore/member';
import { Member } from 'core/api/client/MemberApi';
import { useAppContext } from 'core/hooks';
import { getSitecorePageState } from 'core/utils/sitecore-utils';

import UnauthenticatedHeader from './subcomponents/UnauthenticatedHeader';
import AuthenticatedHeader from './subcomponents/AuthenticatedHeader';
import { IFields } from './Header.sitecore';
import appView from '../appView';

interface IProps {
	fields: IFields;
	theme: IThemeObject;
	isExperienceEditorActive: boolean;
	member: Member;
}

const Header = ({ fields, isExperienceEditorActive, member }: IProps) => {
	const { sitecoreContext } = useAppContext();
	const isSitecorePreview = getSitecorePageState(
		sitecoreContext?.pageState,
		sitecoreContext?.database,
	);

	const isMemberAuthenticated = isAuthenticated(member);
	const isMemberHasMultipleAccount = isMultipleAccounts(member);

	return (
		<div data-target-id="header">
			{isExperienceEditorActive || isSitecorePreview ? (
				<>
					<AuthenticatedHeader
						fields={fields}
						showAccountSwitcher={isMemberHasMultipleAccount}
						logoUrl={fields?.authenticatedHeaderUrl}
					/>
					<ExperienceEditorContent
						startCollapsed
						title="Unauthenticated Header"
					>
						<UnauthenticatedHeader
							logoUrl={fields?.unauthenticatedHeaderUrl}
							logoSrc={fields?.headerLogo}
						/>
					</ExperienceEditorContent>
				</>
			) : isMemberAuthenticated ? (
				!appView() && (
					<AuthenticatedHeader
						fields={fields}
						showAccountSwitcher={isMemberHasMultipleAccount}
						logoUrl={fields?.authenticatedHeaderUrl}
					/>
				)
			) : (
				<UnauthenticatedHeader
					logoUrl={fields?.unauthenticatedHeaderUrl}
					logoSrc={fields?.headerLogo}
				/>
			)}
		</div>
	);
};

export default compose<IProps, {}>(
	withExperienceEditorContext,
	withTheme,
	withMemberContext,
)(Header);
